import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  computed,
  input,
  linkedSignal,
  output
} from '@angular/core';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { featherChevronDown } from '@ng-icons/feather-icons';

import { DropdownOption } from './dropdown-option.model';

@Component({
  selector: 'liv-dropdown-select',
  imports: [NgIconComponent],
  providers: [provideIcons({ featherChevronDown })],
  templateUrl: './dropdown-select.component.html',
  styleUrls: ['./dropdown-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownSelectComponent {
  readonly options = input.required<DropdownOption[]>();
  readonly selectedValue = input<string | number | undefined>();
  readonly triggerLabel = input<string>();
  readonly ariaLabel = input('Selecionar opção');
  readonly expanded = input(false, { transform: booleanAttribute });
  readonly shape = input<'pill' | 'rounded'>('pill');

  readonly selectionChange = output<string | number>();

  readonly expandFilterDropdown = linkedSignal(() => this.expanded());

  readonly hasManyOptions = computed(() => this.options().length > 1);

  readonly displayLabel = computed(() => {
    const explicitLabel = this.triggerLabel();

    if (explicitLabel) {
      return explicitLabel;
    }

    const selected = this.options().find(
      (option) => option.value === this.selectedValue()
    );

    return selected?.label ?? this.options()[0]?.label ?? '';
  });

  readonly visibleOptions = computed(() =>
    this.options().filter((option) => option.value !== this.selectedValue())
  );

  toggleExpandDropdown(): void {
    if (this.hasManyOptions()) {
      this.expandFilterDropdown.update((expanded) => !expanded);
    }
  }

  onClickOutside(): void {
    this.expandFilterDropdown.set(false);
  }

  handleSelectOption(value: string | number): void {
    if (this.selectedValue() === value) {
      this.toggleExpandDropdown();
      return;
    }

    this.selectionChange.emit(value);
    this.expandFilterDropdown.set(false);
  }
}
